import * as React from 'react';
import { Datagrid, DateField, List, TextField, CreateButton, ExportButton, TopToolbar } from 'react-admin';

const ListActions = () => (
  <TopToolbar>
      <CreateButton/>
      <ExportButton maxResults={999999999}/>
  </TopToolbar>
);

export const RoleList = (props: any) => (
  <List actions={<ListActions />} filter={{ _embed: 'permissions' }} {...props}>
    <Datagrid bulkActionButtons={null} rowClick="edit">
      <TextField source="name" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);
